import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

export const StationRouteFooterStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "stationRoute-footer",
})`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};
  gap: 10px;

  transition:
    filter 0.55s ease-out,
    backdrop-filter 0.55s ease-out;
  &.inner-item-editing {
    filter: blur(2px) grayscale(100%);
    backdrop-filter: blur(3px);
    pointer-events: none;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-inline-start: 13px;
    flex-direction: column;
  }
`;

export const StationRouteFooterLeftButtonsStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "stationRoute-footer-left-buttons",
  },
)`
  display: flex;
  align-items: center;
  height: 40px;
  margin-inline-start: 22px;
  gap: 12px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: 20px;
    width: 100%;
    margin-inline-start: 0;
  }
`;

export const StationRouteFooterRightButtonsStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "stationRoute-footer-right-buttons",
  },
)`
  gap: 12px;
  display: flex;
  align-items: center;
  height: 40px;
  margin-inline-end: 12px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-inline-end: 15px;
    width: 100%;
    justify-content: flex-end;
  }
`;
